module.exports = __webpack_public_path__ + "static/labs-group-fall19-42a381ff65c40887f2b139808d056145.jpg";